import { render, staticRenderFns } from "./worldmap.vue?vue&type=template&id=1b80913a&scoped=true&"
import script from "./worldmap.vue?vue&type=script&lang=ts&"
export * from "./worldmap.vue?vue&type=script&lang=ts&"
import style0 from "./worldmap.vue?vue&type=style&index=0&id=1b80913a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80913a",
  null
  
)

export default component.exports